<template>
  <div id="detail_product" class="w-full h-full px-5 py-3">
    <div id="top_bar" class="items-start">
      <div id="back"
           class="text-left col-span-1  col-start-1 row-start-1 1.5xl:col-span-1 1.5xl:col-start-1">
        <button
          class="classen__rounded_full hover__button bg-white w-full md:w-1/3 lg:w-2/3 border-classen__primary border-2"
          @click="close">
          <p class="title leading-none h-auto"><i class="fas fa-angle-left"></i>
            {{ getTranslation(backTo) }}
          </p>
        </button>
      </div>

      <div id="tabs"
           class="flex col-span-2 col-start-1 row-start-1 lg:col-start-2 text-xl">
        <p class="mr-4 pb-2 cursor-pointer" @click="currentTab = 0"
           :class="{'border-b-4 border-classen__primary': currentTab === 0, 'text-gray-500': currentTab === 1}">
          {{ getTranslation('generalInformation') }}
        </p>
        <p @click="currentTab = 1" class="pb-2 cursor-pointer"
           :class="{'border-b-4 border-classen__primary': currentTab === 1, 'text-gray-500': currentTab === 0}">
          {{ getTranslation('downloads') }}
        </p>
      </div>

      <div id="selection"
           class="text-right flex justify-end mr-4 row-start-1 col-start-3 justify-items-start xl:grid-cols-2">
        <p class="leading-none m-0 label" v-if="isCopied"><img class="ml-2"
                                                               src="../../../assets/icons/checkmark.svg"
                                                               alt="checkmark"> URL copied </p>
        <!-- TODO: re-enable -->
        <button v-if="false" class="classen__button copy_button" @click="copyUrl">
          <img src="../../../assets/icons/copy_blue.svg">
        </button>
        <button v-if="currentTab === 1"
                @click="downloadAll"
                class="download_all mr-2 hover__button classen__rounded_full classen__button w-2/3">
          <p class="leading-none" v-if="!isGeneratingExport">{{ getTranslation('downloadAll') }}</p>
          <c-loader v-if="isGeneratingExport" :inline="true" :bg-blur="false"
                    class="transform scale-50"></c-loader>
        </button>
        <c-selection class="ml-2 cSelection" :product="product" :isDetail="true"
                     v-if="displayQuickSelection && hasPermissionToSeeQuickSelections()"
                     :selected-selection="activeSelection"
                     @removeSelectionFromProduct="removeSelectionFromProduct"
                     @addSelectionToProduct="addToSelection"
        />
      </div>
    </div>

    <div id="product_form" class=" mt-5 w-full">
      <c-product-form :show-links="showLinks" :class="{'hidden': currentTab!==0}"
                      class="col-start-2"
                      :product="product"/>
      <c-download-form :class="{'hidden': currentTab!==1}" class="h-full col-start-2"
                       :assets="productAssets"
                       :product="product"/>
    </div>

    <c-confirm v-if="isConfirmCloseVisible"
               :cancel-text="getTranslation('cancel')"
               :confirm-text="getTranslation('yesLeave')"
               :phrase="getTranslation('confirmCloseOnDownload')"
               @cancel="isConfirmCloseVisible = false"
               @confirm="$emit('close')"
    />
  </div>
</template>

<script>
import ProductDetailForm from "./ProductDetailForm";
import SelectionDropdown from "../SelectionDropdown";
import ProductDownloadForm from "./ProductDownloadForm";
import Button from "../../Button";
import getTranslation from "../../../mixins/getTranslation";
import getPermissions from "../../../mixins/getPermissions";
import download from "../../../mixins/download";
import Loader from "../../Loader";
import ConfirmationPopup from "../../form/ConfirmationPopup";

export default {
  name: "ProductDetail",

  components: {
    Button,
    'c-product-form': ProductDetailForm,
    'c-selection': SelectionDropdown,
    'c-download-form': ProductDownloadForm,
    'c-loader': Loader,
    'c-confirm': ConfirmationPopup
  },

  mixins: [getTranslation, getPermissions, download],

  props: {
    product: {required: true},
    activeSelection: {
      required: true,
      default: function () {
        return {id: -1, name: "Set default selection"}
      }
    },
    backTo: {required: false, type: String, default: 'backToArticles'},
    showLinks: {required: false, default: true},
    displayQuickSelection: {required: false, default: true}
  },

  data() {
    return {
      currentTab: 0,
      isGeneratingExport: false,
      isConfirmCloseVisible: false,
      productAssets: [],
      isCopied: false,
    }
  },

  created() {
    this.productAssets = this.product.productAssets;
  },

  methods: {
    close() {
      if (this.isGeneratingExport) {
        this.isConfirmCloseVisible = true;
        return
      }

      this.$emit('close');
    },

    downloadAll() {
      if (this.isGeneratingExport) {
        return
      }

      this.isGeneratingExport = true;
      let urls = {};
      this.productAssets.forEach((asset, index) => {
        urls[`${index + 1}_${asset.type}.jpg`] = asset.asset;
      });

      this.$dashboardStore.dispatch('getImageZip', {images: urls, name: `${this.product.name}.zip`})
        .then((res) => {
          this.downloadFile(res.url);
          this.isGeneratingExport = false;
          this.isConfirmCloseVisible = false;
        })
    },

    removeSelectionFromProduct(selection) {
      this.$dashboardStore.dispatch('removeProductFromSelection', {
        selectionId: selection.id,
        productId: this.product.id
      }).then(() => {
        this.product.selections = this.product.selections.filter((sel) => {
          return sel.id !== selection.id
        })
      })
    },

    addToSelection(selection = null) {
      if (selection === null) {
        this.$dashboardStore.dispatch('addProductToSelection', {
          productId: this.product.id,
          selectionId: this.selectedSelection.id
        }).then(() => {
          this.product.selections.push(this.selectedSelection)
        });
      } else {
        this.$dashboardStore.dispatch('addProductToSelection', {
          productId: this.product.id,
          selectionId: selection.id
        }).then(() => {
          this.product.selections.push(selection)
        });
      }
    },

    copyUrl() {
      const basePath = window.location.host;
      const protocol = window.location.protocol;
      const url = `${protocol}//${basePath}/#/product/${this.product.id}`;
      navigator.clipboard.writeText(url);
      this.isCopied = true;
    }
  }

}
</script>

<style scoped>
#tabs > label {
  height: 25px;
  width: fit-content;
}

#top_bar {
  height: 50px;
  display: grid;
  grid-template-columns: 18% 58% 24%;
}

#product_form {
  height: calc(100% - 50px);
}

#product_form {
  display: grid;
  grid-template-columns: 18% 64% 18%;
}

.download_all {
  padding-left: 0;
  height: 40px;
}

.cSelection {
  width: 200px
}

#back {
  width: 250px !important
}

.copy_button {
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.copy_button > img {
  width: 22px;
  height: 22px;
}

.label {
  display: flex;
  height: 42px;
  line-height: 42px;
  @apply mr-2 text-classen__primary;
}

.label > img {
  height: 20px;
  margin-top: 11px;
}

</style>
